const eventBus = {
  events: {},

  on(eventName, callback) {
    if (!this.events[eventName]) this.events[eventName] = [];
    this.events[eventName].push(callback);
  },

  emit(eventName, data) {
    const listeners = this.events[eventName] || [];
    listeners.forEach((cb) => cb(data));
  },

  off(eventName, callback) {
    this.events[eventName] = (this.events[eventName] || []).filter(
      (cb) => cb !== callback
    );
  },
};

export default eventBus;
